// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"3c65ee52","277":"08507676","455":"c17aaaac","457":"eded04df","895":"bfc8ad3a","913":"9ed78159","946":"f8852d3e"}[chunkId] + ".chunk.js";
};